import { AutoEnablePlugins, InteractiveSubRenderContribution, configureRuntimeApplicationForApp, getLegacyBindingContext, getRuntimeInstallerBindingContext, installRuntimeGraphicRenderersToApp, refreshRuntimeInstallerContributions } from "@visactor/vrender-core";

import { PopTipRenderContribution } from "./contribution";

import { PopTipPlugin, PopTipForClipedTextPlugin } from "./poptip-plugin";

function bindPoptip(container) {
    container.isBound(PopTipRenderContribution) || (container.bind(PopTipRenderContribution).toSelf().inSingletonScope(), 
    container.bind(InteractiveSubRenderContribution).toService(PopTipRenderContribution)), 
    container.isBound(PopTipPlugin) || (container.bind(PopTipPlugin).toSelf(), container.bind(AutoEnablePlugins).toService(PopTipPlugin)), 
    container.isBound(PopTipForClipedTextPlugin) || (container.bind(PopTipForClipedTextPlugin).toSelf(), 
    container.bind(AutoEnablePlugins).toService(PopTipForClipedTextPlugin));
}

export function installPoptipToApp(app) {
    if (!app) throw new Error("installPoptipToApp requires an app instance");
    configureRuntimeApplicationForApp(app), bindPoptip(getRuntimeInstallerBindingContext()), 
    refreshRuntimeInstallerContributions(), installRuntimeGraphicRenderersToApp(app);
}

export function loadPoptip() {
    bindPoptip(getLegacyBindingContext()), bindPoptip(getRuntimeInstallerBindingContext()), 
    refreshRuntimeInstallerContributions();
}
//# sourceMappingURL=module.js.map
